import { configureStore } from '@reduxjs/toolkit';
import permissionReducer from '../reducer/permission.reducer';
import resourceReducer from '../reducer/resource.reducer';

export const store = configureStore({
  reducer: {
    resource: resourceReducer,
    permission: permissionReducer,
  },
  devTools: process.env.NODE_ENV !== 'production',
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
